import { tokenizeJsonPath } from './json-grammar.js';
export function parseJSON(raw) {
    try {
        return { ok: true, root: JSON.parse(raw) };
    }
    catch (e) {
        return { ok: false, error: e.message };
    }
}
export function evaluateJsonPath(root, path) {
    const tok = tokenizeJsonPath(path);
    if ('error' in tok)
        return { found: false, error: tok.error };
    let cursor = root;
    for (const t of tok.tokens) {
        if (cursor === null || cursor === undefined)
            return { found: false };
        if (t.kind === 'key') {
            if (typeof cursor !== 'object' || Array.isArray(cursor))
                return { found: false };
            if (!(t.name in cursor))
                return { found: false };
            cursor = cursor[t.name];
        }
        else {
            if (!Array.isArray(cursor))
                return { found: false };
            if (t.wildcard) {
                if (cursor.length === 0)
                    return { found: false };
                cursor = cursor[0];
            }
            else {
                const el = cursor[t.index];
                if (el === undefined)
                    return { found: false };
                cursor = el;
            }
        }
    }
    return { found: true, value: cursor };
}
//# sourceMappingURL=json-parse.js.map